import { API_ENDPOINTS, API_ERROR_MESSAGES } from "../constants/api";
import { apiFetch } from "./apiClient";

export class DailyAssignmentApiError extends Error {
  constructor(message, details = []) {
    super(message);
    this.name = "DailyAssignmentApiError";
    this.details = details;
  }
}

async function readDailyAssignmentResponse(
  response,
  readFailedMessage,
  requestFailedMessage,
) {
  let result;

  try {
    result = await response.json();
  } catch {
    throw new DailyAssignmentApiError(readFailedMessage);
  }

  if (!response.ok || !result?.success) {
    throw new DailyAssignmentApiError(
      result?.message || requestFailedMessage,
      Array.isArray(result?.details) ? result.details : [],
    );
  }

  return result.data;
}

export async function fetchDailyAssignmentMetadata() {
  const response = await apiFetch(
    API_ENDPOINTS.telecallingRecords.dailyAssignment.metadata,
    { cache: "no-store" },
  );

  return readDailyAssignmentResponse(
    response,
    API_ERROR_MESSAGES.dailyAssignmentMetadataReadFailed,
    API_ERROR_MESSAGES.dailyAssignmentMetadataFetchFailed,
  );
}

export async function searchDailyAssignments(payload) {
  const response = await apiFetch(
    API_ENDPOINTS.telecallingRecords.dailyAssignment.search,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );

  return readDailyAssignmentResponse(
    response,
    API_ERROR_MESSAGES.dailyAssignmentSearchReadFailed,
    API_ERROR_MESSAGES.dailyAssignmentSearchFailed,
  );
}

export async function assignDailyAssignments(payload) {
  const response = await apiFetch(
    API_ENDPOINTS.telecallingRecords.dailyAssignment.assign,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );

  return readDailyAssignmentResponse(
    response,
    API_ERROR_MESSAGES.dailyAssignmentAssignReadFailed,
    API_ERROR_MESSAGES.dailyAssignmentAssignFailed,
  );
}
